import React from "react";
import EmploymentCheck from "./EmploymentCheck";

function Employment() {
  return (
    <>
      <section class="bg-white dark:bg-gray-900">
        <div class="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
          <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">
            Employment Form
          </h2>
          <form action="#" class="space-y-8">
            <div>
              <label
                for="email"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Your name
              </label>
              <input
                type="email"
                id="name"
                class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="Name"
                required
              />
            </div>
            <div>
              <label
                for="email"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Your email
              </label>
              <input
                type="email"
                id="email"
                class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="Email"
                required
              />
            </div>
            <div>
              <label
                for="subject"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Mailing Address
              </label>
              <input
                type="text"
                id="address"
                class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="Let us know how we can help you"
                required
              />
            </div>
            <div class="sm:col-span-2">
              <label
                for="message"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Salary Expectations
              </label>
              <textarea
                id="message"
                rows="3"
                class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                placeholder="Leave a comment..."
              ></textarea>
            </div>
            <div className="grid grid-cols-3">
              <EmploymentCheck title="A1" />
              <EmploymentCheck title="A2" />
              <EmploymentCheck title="RF" />
              <EmploymentCheck title="V1" />
              <EmploymentCheck title="V2" />
              <EmploymentCheck title="LED Video Wall" />
              <EmploymentCheck title="Camera Op" />
              <EmploymentCheck title="Projectionist" />
              <EmploymentCheck title="Graphics Op" />
              <EmploymentCheck title="Powerpoint Op" />
              <EmploymentCheck title="Robo-cam Op" />
              <EmploymentCheck title="L1" />
              <EmploymentCheck title="L2" />
              <EmploymentCheck title="Rigger" />
              <EmploymentCheck title="Rigger Assist" />
              <EmploymentCheck title="Stagehand" />
              <EmploymentCheck title="Breakout Lead" />
              <EmploymentCheck title="Breakout Tech" />
              <EmploymentCheck title="Carpentry/Scenic" />
              <EmploymentCheck title="Electrician" />
            </div>
            <button
              type="submit"
              class="bg-transparent hover:bg-cyan-500 text-cyan-300 font-semibold hover:text-white py-2 px-4 border border-cyan-500 hover:border-transparent rounded mb-4"
            >
              Send message
            </button>
          </form>
        </div>
      </section>
    </>
  );
}

export default Employment;
